import styled from 'styled-components';
import ButtonIcon from 'components/ButtonIcon';
import { PURPLE_500 } from '../../constants';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    min-height: 6rem;  
`;

export const ActionsContainer = styled.div`
    position: absolute;
    display: flex;
    align-items: center;
    gap: 0.25rem;
    top: 0;
    right: 0.5rem;
    padding: 0;
    height: 1.875rem;
`;

export const ActionButton = styled(ButtonIcon)`
    color: ${PURPLE_500};
    width: 1.5rem;
    height: 1.5rem;

    svg {
        width: 1rem !important;
        height: 1rem !important;
        font-size: 1rem !important;
    }
`;
